export enum ClientStatus {
  PROSPECT = 'PROSPECT',
  QUALIFIED_PROSPECT = 'QUALIFIED_PROSPECT',
  CLIENT = 'CLIENT',
}

export const getClientStatusLabel = (
  value: ClientStatus | null | undefined
): string => {
  switch (value) {
    case ClientStatus.PROSPECT:
      return $localize`Prospect`;
    case ClientStatus.QUALIFIED_PROSPECT:
      return $localize`Prospect qualifié`;
    case ClientStatus.CLIENT:
      return $localize`Client`;
    default:
      return '';
  }
};
